import { Project, ProjectBasicContact } from "./ProjectInterface";

export  interface ShareContact {
    by: string;
    id: number;
    // can_edit:0|1;
  }

  export const mapShareContact = (data:any): ShareContact => {
    if(!data){
        throw new Error('Invalied employee type')
    }

    const shareContact: ShareContact = {
        by: data.by,
        id: data.id,
        // can_edit:data.can_edit
    }

    return shareContact;
}

export const mapShareContacts = (data: any[]): ShareContact[] => {
    if (!Array.isArray(data)) {
      throw new Error('Invalid Service Type data');
    }
  
    return data.map(mapShareContact);
  };

  export  interface ProjectBasicContactWithProject {
    contact: ProjectBasicContact[];
    project: Project;
  }

  //===========================================================
  export  interface ShareContactDetails {
    by: string;
    id: number;
    folder_id: number;
    first_name: string;
    last_name: string;
    profile_image: string;
    mobile: string;
    landline: string;
    email: string;
    address?: string;
    city?: string;
    post_code?: string;
    role_name: string;
    isCheckedForShare?: boolean;
    isCheckedForEdit?: boolean;
    isCheckedForView?: boolean;

  }

  export const mapShareContactDetails = (data:any): ShareContactDetails => {
    if(!data){
        throw new Error('Invalied ShareContactDetails')
    }


    const ShareContactDetails: ShareContactDetails = {
        by: data.by,
        id: data.id,
        folder_id: data.folder_id,
        first_name: data.first_name,
        last_name: data.last_name,
        profile_image: data.profile_image,
        mobile: data.mobile,
        landline: data.landline,
        email: data.email,
        address: data.address,
        city: data.city,
        post_code: data.post_code,
        role_name: data.by,
        isCheckedForShare: false,
        isCheckedForEdit: false,
        isCheckedForView: false,
    }

    return ShareContactDetails;

}

export const mapShareContactDetailsList = (data: any[]): ShareContactDetails[] => {
    if (!Array.isArray(data)) {
      throw new Error('Invalid ShareContactDetails data');
    }
  
    return data.map(mapShareContactDetails);
  };

  export  interface ShareContactDetailsPayload {
    id: number;
    isChecked: boolean;

  }